import { render } from "./RedefinirSenha.vue?vue&type=template&id=346a2e50&scoped=true&ts=true"
import script from "./RedefinirSenha.vue?vue&type=script&lang=ts"
export * from "./RedefinirSenha.vue?vue&type=script&lang=ts"

import "./RedefinirSenha.vue?vue&type=style&index=0&id=346a2e50&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346a2e50"]])

export default __exports__